import providers from '../../api/providers'

export default {
    namespaced: true,
    state: () => ({
        loading: false,
        items: []
    }),
    getters: {},
    actions: {
        getProviders ({ commit }) {
            commit('setLoading', true)
            return providers.getProviders().then((response) => {
                commit('setItems', response.data.providers)
                commit('setLoading', false)
            })
        }
    },
    mutations: {
        setLoading (state, bool) {
            state.loading = bool
        },
        setItems (state, data) {
            state.items = data
        }
    }
}
